import { useAppSelector } from '../../hooks';
import { selectActiveAlarms } from '../../containers/Alarm/AlarmSlice';
import { parseSentTime } from '../parseSentTime';

export const useActiveBlockingAlarm = () =>
  useAppSelector(selectActiveAlarms)
    .filter(a => a.isBlockingOtherAlarms)
    .sort((a, b) => parseSentTime(b.sent) - parseSentTime(a.sent))[0];
